import Vue from 'vue';
import _ from 'lodash';
import apiClient from '@/apiClient';

const state = {
  commonMarkups: {
    1: {
      part_price_wardrobe: 0,
      part_price_doors: 0,
      // waste_common: 0,
      assembly: 0,
      shipping: 0
    }
  }
};

const actions = {
  getCommonMarkups: ({ commit }, { firmId }) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/markups`)
        .then(response => {
          const markups = state.commonMarkups;
          const mergedMarkups = _.merge(markups, response.data.markups);
          commit('commonMarkups', mergedMarkups);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  updateCommonMarkup: (_context, { firmId, constructorId, name, markup }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put(`/firms/${firmId}/markups`, {
          constructorId,
          name: name.toUpperCase(),
          markup
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    })
};

const mutations = {
  commonMarkups: (state, markups) => {
    Vue.set(state, 'commonMarkups', markups);
  }
};

export default {
  state,
  actions,
  mutations
};
